// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"908ac6bd","239":"0c214e9d","453":"d1e20502","455":"46219c5d"}[chunkId] + ".chunk.js";
};